/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import styles from './ContactForm.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectContactFormActive, 
  changeContactFormAction,
} from '../../ducks';
import { 
  SlideIn, 
  SlideInHeader,
} from '../slidein';
import c from 'classnames';
import { CONTACTFORM } from '../../lib/labels';
import { 
  ClickElement, 
  InputField,
} from '../form';
import { submitContactForm} from '../../apis/dumpert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SelectElement } from '../form/SelectElement';
import { settings } from '../../settings';

const getExternalHref = selected => {
  const baseUrl = 'https://reaguurder.nl';
  const urlPath = () => {
    switch (selected) {
    case 'no_confirm_mail':
      return '/user/resend-confirm-email';
    case 'password_reset':
      return '/user/forgot-password';
    case 'password_change':
      return '/user/sign-in?next=https%3A//reaguurder.nl/user/change-password';
    case 'email_change':
      return '/user/sign-in?next=https%3A//reaguurder.nl/user/change_email';           
    case 'username_change':          
      return '/user/sign-in?next=https%3A//reaguurder.nl/user/change_username';
    case 'delete_account':
      return '/user/sign-in?next=https%3A//reaguurder.nl/user/delete';
    case 'gdpr':
      return '/contact';         
    default:
      return;
    }
  };
  return `${baseUrl}${urlPath()}`;
};

const openExternalHref = selected => {
  window.open(getExternalHref(selected), '_blank', 'noopener, noreferrer');
};

export const ContactForm = () => {

  const contactFormActive = useSelector(selectContactFormActive);
  const dispatch = useDispatch();
  const recaptchaRef = React.createRef();
  const [name, setName] = useState('');
  const [senderMail, setSenderMail] = useState('');
  const [phoneNum, setPhoneNum] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({});
  const selected = () => {
    if (receiverMail !== '' && receiverMail === 'gdpr') {
      return receiverMail;
    } else if (loginRegisterProblem !== '') {
      return loginRegisterProblem;
    }
  };

  const receiverMailOptions = [
    {label: 'Algemene vragen', value: 'Algemene Vragen'},
    {label: 'DumpertReeten', value: 'DumpertReeten'},
    {label: 'Dumpert Filmt je Werkplek', value: 'Dumpert Filmt Je Werkplek'},
    {label: 'Problemen met inloggen of registreren', value: 'problem'},
    {label: 'Reaguren', value: 'Reaguren'},
    {label: 'Sales', value: 'Sales'},
    {label: 'Verwijderverzoek', value: 'Verwijderverzoek'},
    {label: 'GDPR gegevens opvragen', value: 'gdpr'},
    {label: 'Vragen over de GDPR', value: 'Vragen over de GDPR'},
    {label: 'Anders', value: 'Anders'},
  ];
  const [receiverMail, setReceiverMail] = useState(receiverMailOptions[0].value);

  const loginRegisterOptions = [
    {label: 'Ik heb problemen met...', value: ''},
    {label: 'Ik heb geen bevestigingsmail gekregen', value: 'no_confirm_mail'},
    {label: 'Wachtwoord herstellen', value: 'password_reset'},
    {label: 'Wachtwoord veranderen', value: 'password_change'},
    {label: 'Emailadres veranderen', value: 'email_change'},
    {label: 'Username veranderen', value: 'username_change'},
    {label: 'Account verwijderen / vergeten worden', value: 'delete_account'},
  ];
  const [loginRegisterProblem, setLoginRegisterProblem] = useState(loginRegisterOptions[0].value);

  const buttonText = !loading
    ? CONTACTFORM.SEND :
    <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />;

  const submit = async e => {
    e.preventDefault();
    setLoading(true);

    const token = await recaptchaRef.current.executeAsync();

    submitContactForm({
      'name': name,
      'sender': senderMail,
      'phone': phoneNum,
      'description': description,
      'subject': receiverMail,
      'g-recaptcha-response': token,
    })
      .then(() => {
        setName('');
        setSenderMail('');
        setPhoneNum('');
        setDescription('');
        setLoading(false);
        setNotification({ state: 'success', message: CONTACTFORM.SUCCESS });
      })
      .catch(error => {
        setLoading(false);
        if (error.response && error.response.status === 403) {
          setNotification({ state: 'error', message: CONTACTFORM.TIMEOUT });
        } else {
          setNotification({ state: 'error', message: CONTACTFORM.ERROR });
        }
      });
  };

  useEffect(() => {
    if(selected()) {
      openExternalHref(selected());
    }
  }, [loginRegisterProblem, receiverMail]);

  return (
    <SlideIn
      isActive={contactFormActive}
      changeActiveState={() => dispatch(changeContactFormAction())}
    >
      <div className={styles.contactform}>
        <SlideInHeader
          titleText={CONTACTFORM.TITLE}
          clickHandler={changeContactFormAction(!contactFormActive)}
        />
        <div>
          <div className={styles.text_block}>
            <p>
              Kies hieronder het onderwerp waarover je contact wil opnemen. Iets insturen kan via
              'Uploaden of linktippen' in het menu.
            </p>
            <p>
              Heb je een klacht over een bepaald filmpje of foto? Dat verbaast ons niks, daar ben je
              Nederlander voor. Kies dan ‘verwijderverzoek’ en <strong>VERGEET NIET </strong> te vermelden 
              over welke post het precies gaat en je relatie tot deze content. 
              Anders nemen we je klacht simpelweg niet in behandeling.
            </p>
          </div>
          {(notification.state === 'success' || notification.state === 'error') && (
            <div className={c(styles.notification, {
              [styles.success]: notification.state === 'success',
              [styles.error]: notification.state === 'error',
            })}>
              <div>{notification.message}</div>
              <div className={styles.close} onClick={() => setNotification({})} >
                <FontAwesomeIcon icon={['fas', 'times']} size="lg" />
              </div>
            </div>
          )}
          <form onSubmit={e => submit(e)}>
            <h3>Ik mail over:</h3>
            <SelectElement
              name="contactform_receiver_mail"
              value={receiverMail}
              onChange={e => setReceiverMail(e.target.value)}
              options={receiverMailOptions}
            />
            {receiverMail === 'problem' && (
              <>
                <p>
                  Selecteer je probleem:
                </p>
                <SelectElement
                  name="contactform_login_register_problem"
                  value={loginRegisterProblem}
                  onChange={e => setLoginRegisterProblem(e.target.value)}
                  options={loginRegisterOptions}
                />
              </>
            )}
            {((receiverMail === 'problem' && loginRegisterProblem !== '') || receiverMail === 'gdpr' ) && (
              <>
                <p style={{ marginTop: '-5px', marginLeft: '5px', marginBottom: '5px' }}>
                  <small>
                    <strong>LET OP:</strong> er wordt een nieuwe pagina geopend. 
                  Wordt er geen pagina geopend controleer dan of pop-ups worden geblokkeerd. 
                  Is dat niet het geval, klik dan op onderstaande button:
                  </small>
                </p>
                <ClickElement
                  primary
                  ElementType='a'
                  text='open link'
                  href={getExternalHref(selected())}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              </>
            )}
            {(receiverMail !== 'problem' && receiverMail !== 'gdpr' ) && (
              <>
                <InputField
                  name="contactform_name"
                  type="text"
                  placeholder={CONTACTFORM.PLACEHOLDER.NAME}
                  autoComplete="off"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  required
                />
                <InputField
                  name="contactform_mail"
                  type="email"
                  placeholder={CONTACTFORM.PLACEHOLDER.EMAIL}
                  autoComplete="email"
                  value={senderMail}
                  onChange={e => setSenderMail(e.target.value)}
                  required
                />
                <InputField
                  name="contactform_phone"
                  type="tel"
                  placeholder={CONTACTFORM.PLACEHOLDER.TELEPHONE}
                  autoComplete="off"
                  value={phoneNum}
                  onChange={e => setPhoneNum(e.target.value)}
                />
                <textarea
                  name="description"
                  className={'textarea'}
                  rows={'5'}
                  placeholder={CONTACTFORM.PLACEHOLDER.DESCRIPTION}
                  autoComplete="off"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                />
                <ClickElement
                  ElementType="button"
                  type="submit"
                  text={buttonText}
                  primary
                />
              </>
            )}
            <ReCAPTCHA
              ref={recaptchaRef}
              size="invisible"
              sitekey={settings.RECAPTCHA_PUBLIC_KEY} />
          </form>
        </div>
      </div>
    </SlideIn>
  );
};
